import * as Actions from "../../store/actions";

import { MainPropsTypes, ParentItemsTypes } from "../types";
import { availableLanguages, translate } from "../../translation";
import { createElement, useEffect, useState } from "react";

import BarChartOutlined from "@ant-design/icons/BarChartOutlined";
import BookOutlined from "@ant-design/icons/BookOutlined";
import Breadcrumb from "antd/lib/breadcrumb";
import CaretDownOutlined from "@ant-design/icons/CaretDownOutlined";
import ConfigProvider from "antd/lib/config-provider";
import DashOutlined from "@ant-design/icons/DashOutlined";
import Dropdown from "antd/lib/dropdown";
import FileDoneOutlined from "@ant-design/icons/FileDoneOutlined";
import GlobalOutlined from "@ant-design/icons/GlobalOutlined";
import InfoCircleOutlined from "@ant-design/icons/InfoCircleOutlined";
import Layout from "antd/lib/layout";
import { Link } from "react-router-dom";
import LogoutOutlined from "@ant-design/icons/LogoutOutlined";
import Menu from "antd/lib/menu";
import MenuFoldOutlined from "@ant-design/icons/MenuFoldOutlined";
import type { MenuProps } from "antd/es/menu/menu";
import MenuUnfoldOutlined from "@ant-design/icons/MenuUnfoldOutlined";
import SettingOutlined from "@ant-design/icons/SettingOutlined";
import Space from "antd/lib/space";
import Splitter from "../../components/ui/splitter";
import { StateTypes } from "../../store/types";
import User from "../../services/user";
import UserOutlined from "@ant-design/icons/UserOutlined";
import { connect } from "react-redux";
import { decryptData } from "../../services/encryption";
import logo from "../../assets/LogoKaiDoc-white2.png";
import logo_mini from "../../assets/LogoD_128.png";
import styles from "./styles.module.scss";
import ukUA from "antd/locale/uk_UA";

//UI

//Icons

//Locale

const { Header, Sider, Content } = Layout;
type MenuItem = Required<MenuProps>["items"][number];

function MainLayout(props: MainPropsTypes) {
  const [collapsed, setCollapsed] = useState(false);
  const [parent, setParent] = useState<string[]>([]);
  const [parentItems, setParentItems] = useState<ParentItemsTypes[]>([]);
  const [openKeys, setOpenKeys] = useState(
    JSON.parse(localStorage.getItem("open-keys") || "null") || ["sub1"]
  );
  const currentUser = User.decode();
  const logoStyles = [styles["logo"]];
  if (collapsed) {
    logoStyles.push(styles["collapsed"]);
  }

  const intl = (selector: string) => translate(selector, props.lang ?? "uk");

  useEffect(() => {
    if (!currentUser) window.location.href = "/auth";
    if (parent.length === 0 || parentItems.length === 0) {
      getParentRoutes();
    }
  }, [currentUser, parent, parentItems]);

  const getParentRoutes = async () => {
    const accesses = decryptData();
    if (accesses) {
      setParent(accesses.map((i: { parentRoute: string }) => i?.parentRoute));
      setParentItems(accesses);
    } else {
      window.location.href = "/auth";
    }
  };

  const getItem = (
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    title?: string
  ): MenuItem => ({
    key,
    icon,
    children,
    label,
    title,
  });

  const generateMenuItems = () => {
    const docsObjs = parentItems.filter((obj) => obj.parentRoute === "docs");
    const dynamicDocsObjs = parentItems.filter(
      (obj) => obj.parentRoute === "dynamic-docs"
    );
    let startDocsId = 2;
    return [
      ...(parent?.includes("info")
        ? [
            getItem(
              <Link to="/information">{intl("information")}</Link>,
              "1",
              <InfoCircleOutlined />,
              undefined,
              intl("information")
            ),
          ]
        : []),
      ...(parent?.includes("docs") || parent?.includes("dynamic-docs")
        ? [
            getItem(intl("documents"), "sub1", <FileDoneOutlined />, [
              ...docsObjs.map((obj, index) =>
                getItem(
                  <Link key={index} to={obj.route}>
                    {intl(obj.translate)}
                  </Link>,
                  obj.idRoute,
                  undefined,
                  undefined,
                  obj.name
                )
              ),
              ...dynamicDocsObjs.map((obj, index) =>
                getItem(
                  <Link key={index} to={obj.route}>
                    {props.lang == "uk"? obj.name: obj.translate}
                  </Link>,
                  (startDocsId + docsObjs.length + index).toString(),
                  undefined,
                  undefined,
                  obj.name
                )
              ),
            ]),
          ]
        : []),
      ...(parent?.includes("stats")
        ? [
            getItem(
              <Link to="/statistics">{intl("statistics")}</Link>,
              "20",
              <BarChartOutlined />,
              undefined,
              intl("statistics")
            ),
          ]
        : []),
      ...(parent?.includes("dirs")
        ? [
            getItem(
              <Link to="/directories">{intl("directories")}</Link>,
              "12",
              <BookOutlined />,
              undefined,
              intl("directories")
            ),
          ]
        : []),
      ...(parent?.includes("admin")
        ? [
            getItem(
              <Link to="/administration">{intl("administration")}</Link>,
              "7",
              <SettingOutlined />,
              undefined,
              intl("administration")
            ),
          ]
        : []),
    ];
  };

  const menuItems = generateMenuItems();

  const dynamicDocsRoutes =
  (parent?.includes("docs") || parent?.includes("dynamic-docs"))
    ? (() => {
        const docsObjs = parentItems.filter((obj) => obj.parentRoute === "docs");
        const dynamicDocsObjs = parentItems.filter(
          (obj) => obj.parentRoute === "dynamic-docs"
        );
        const result: Record<string, any> = {};

      let startDocsId = 2;
      dynamicDocsObjs.map((item, index) => {
          result[item.route] = {
            id: [item?.idRoute?.toString() || docsObjs.find(x=>x.idRoute === docsObjs.length + index + startDocsId) ? item.id?.toString() : (docsObjs.length + index + startDocsId)?.toString()],
            title: intl("documents"),
            breadcrump: props.lang == "uk"? item.name: item.translate,
          };
        });
        return result;
      })()
    : {};

  const routesObj = {
    "/profile": { id: [], title: intl("profile"), breadcrump: null },
    "/information": { id: ["1"], title: intl("information"), breadcrump: null },
    // DOCUMENTS
    "/documents/incoming": {
      id: ["2"],
      title: intl("documents"),
      breadcrump: intl("incoming"),
    },
    "/documents/outcoming": {
      id: ["3"],
      title: intl("documents"),
      breadcrump: intl("outcoming"),
    },
    "/documents/internal": {
      id: ["4"],
      title: intl("documents"),
      breadcrump: intl("internal"),
    },
    // "/documents/internalview": {
    //   id: ["4"],
    //   title: intl("documents"),
    //   breadcrump: intl("internal"),
    // },
    "/documents/resolutions": {
      id: ["5"],
      title: intl("documents"),
      breadcrump: intl("resolutions"),
    },
    "/documents/for-signature": {
      id: ["6"],
      title: intl("documents"),
      breadcrump: intl("for-signature"),
    },
    "/documents/electronic-mail": {
      id: ["38"],
      title: intl("documents"),
      breadcrump: intl("electronic-mail"),
    },
    // DYNAMIC DOCUMENTS
    ...dynamicDocsRoutes,
    // DIRECTORIES
    "/directories": {
      id: ["12"],
      title: intl("directories"),
      breadcrump: null,
    },
    // DOCUMENTS CHARACTERISTICS
    "/directories/actions-with-documents": {
      id: ["12"],
      title: intl("directories"),
      breadcrump: intl("actions-with-documents"),
    },
    "/directories/nomenclature-of-cases-current": {
      id: ["12"],
      title: intl("directories"),
      breadcrump: intl("nomenclature-of-cases-current"),
    },
    "/directories/nomenclature-of-cases": {
      id: ["12"],
      title: intl("directories"),
      breadcrump: intl("nomenclature-of-cases"),
    },
    "/directories/resolution-templates": {
      id: ["12"],
      title: intl("directories"),
      breadcrump: intl("resolution-templates"),
    },
    "/directories/types-of-documents": {
      id: ["12"],
      title: intl("directories"),
      breadcrump: intl("types-of-documents"),
    },
    "/directories/indexes-of-documents": {
      id: ["12"],
      title: intl("directories"),
      breadcrump: intl("indexes-of-documents"),
    },
    "/directories/types-of-deliveries": {
      id: ["12"],
      title: intl("directories"),
      breadcrump: intl("types-of-deliveries"),
    },
    "/directories/types-of-communication": {
      id: ["12"],
      title: intl("directories"),
      breadcrump: intl("types-of-communication"),
    },
    "/directories/results-of-actions": {
      id: ["12"],
      title: intl("directories"),
      breadcrump: intl("results-of-actions"),
    },
    "/directories/document-categories": {
      id: ["12"],
      title: intl("directories"),
      breadcrump: intl("document-categories"),
    },
    "/directories/types-of-relationships-between-documents": {
      id: ["12"],
      title: intl("directories"),
      breadcrump: intl("types-of-relationships-between-documents"),
    },
    "/directories/types-of-receipts": {
      id: ["12"],
      title: intl("directories"),
      breadcrump: intl("types-of-receipts"),
    },
    // HR DEPARTMENT
    "/directories/profession-classifier": {
      id: ["12"],
      title: intl("directories"),
      breadcrump: intl("profession-classifier"),
    },
    "/directories/job-categories": {
      id: ["12"],
      title: intl("directories"),
      breadcrump: intl("job-categories"),
    },
    "/directories/types-of-structural-unit": {
      id: ["12"],
      title: intl("directories"),
      breadcrump: intl("types-of-structural-unit"),
    },
    "/directories/employees": {
      id: ["12"],
      title: intl("directories"),
      breadcrump: intl("employees"),
    },
    "/directories/structural-units": {
      id: ["12"],
      title: intl("directories"),
      breadcrump: intl("structural-units"),
    },
    "/directories/positions": {
      id: ["12"],
      title: intl("directories"),
      breadcrump: intl("positions"),
    },
    "/directories/employees-and-contact-persons": {
      id: ["12"],
      title: intl("directories"),
      breadcrump: intl("employees-and-contact-persons"),
    },
    "/directories/departmental-journals": {
      id: ["12"],
      title: intl("directories"),
      breadcrump: intl("departmental-journals"),
    },
    "/directories/groups-of-correspondents": {
      id: ["12"],
      title: intl("directories"),
      breadcrump: intl("groups-of-correspondents"),
    },
    // GENERAL
    "/directories/correspondents": {
      id: ["12"],
      title: intl("directories"),
      breadcrump: intl("correspondents"),
    },
    // ADMINISTRATION
    "/administration": {
      id: ["7"],
      title: intl("administration"),
      breadcrump: null,
    },
    "/administration/configuring-page-access": {
      id: ["7"],
      title: intl("administration"),
      breadcrump: intl("configuring-page-access"),
    },
    "/administration/button-access-settings": {
      id: ["7"],
      title: intl("administration"),
      breadcrump: intl("button-access-settings"),
    },
    "/administration/server-settings": {
      id: ["7"],
      title: intl("administration"),
      breadcrump: intl("server-settings"),
    },
    "/administration/users": {
      id: ["7"],
      title: intl("administration"),
      breadcrump: intl("users"),
    },
    "/administration/document-display-options": {
      id: ["7"],
      title: intl("administration"),
      breadcrump: intl("document-display-options"),
    },
    "/administration/barcode-application-options": {
      id: ["7"],
      title: intl("administration"),
      breadcrump: intl("barcode-application-options"),
    },
    "/administration/mailboxes": {
      id: ["7"],
      title: intl("administration"),
      breadcrump: intl("mailboxes"),
    },
    "/administration/mailboxes-by-user": {
      id: ["7"],
      title: intl("administration"),
      breadcrump: intl("mailboxes-by-user"),
    },
  };

  const onOpenChange = (openKeys: string[]) => {
    setOpenKeys(() => {
      localStorage.setItem("open-keys", JSON.stringify(openKeys));
      return openKeys;
    });
  };

  const resolveActiveSelectedMenu = (path: string) =>  routesObj[path as keyof typeof routesObj]?.id || ["0"];
  const activeLink = resolveActiveSelectedMenu(props.activeLink);

  const resolveTitle = (path: string) =>
    routesObj[path as keyof typeof routesObj]?.title || null;

  const resolveBreadcrump = (path: string) =>
    routesObj[path as keyof typeof routesObj]?.breadcrump || null;

  const breadcrumbItems = [
    { title: intl("cabinet") },
    {
      title: props.activeLink.includes("/documents") ? (
        resolveTitle(props.activeLink)
      ) : (
        <a href={`/${props.activeLink.split("/")[1]}`}>
          {resolveTitle(props.activeLink)}
        </a>
      ),
    },
  ];

  resolveBreadcrump(props.activeLink) &&
    breadcrumbItems.push({
      title: (
        <a href={props.activeLink}>{resolveBreadcrump(props.activeLink)}</a>
      ),
    });

  const languageItems: MenuProps["items"] = availableLanguages;
  const userItems: MenuProps["items"] = [
    { key: "1", label: intl("profile"), icon: <UserOutlined /> },
    { type: "divider" },
    { key: "2", danger: true, label: intl("logout"), icon: <LogoutOutlined /> },
  ];
  const footerItems: MenuProps["items"] = [
    {
      key: "1",
      label: (
        <Link to="/footer/privacy-policy" className={styles["link"]}>
          {intl("privacy-policy")}
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link to="/footer/terms-of-use" className={styles["link"]}>
          {intl("terms-of-use")}
        </Link>
      ),
    },
    {
      key: "3",
      label: (
        <Link to="/footer/support" className={styles["link"]}>
          {intl("support")}
        </Link>
      ),
    },
  ];

  const onClickLanguage: MenuProps["onClick"] = ({ key }) => {
    const language = availableLanguages.find(
      (lang) => lang.key === Number(key)
    );
    if (language) {
      props.changeLanguage(language.code);
    }
  };

  const onClickUser: MenuProps["onClick"] = ({ key }) => {
    if (Number(key) === 1) {
      window.location.href = "/profile";
    } else {
      User.unset();
      window.location.href = "/auth";
    }
  };

  const currentLanguageLabel = availableLanguages.find(
    (lang) => lang.code === props.lang
  )?.label;

  // const extraButtons: Partial<Record<string, JSX.Element>> = {
  return (
    <Layout className={styles["main-layout"]}>
      <Splitter
        collapsed={collapsed}
        leftComponent={
          <Sider
            className={styles["sider"]}
            trigger={null}
            collapsible
            collapsed={collapsed}
          >
            {!collapsed ? 
            <div className={logoStyles.join(" ")}>
              <img src={logo} alt="Logo" />
            </div>
            :
            <div className={logoStyles.join(" ")}>
              <img src={logo_mini} alt="Logo" />
            </div>
          }


            <Menu
              className={styles["menu"]}
              mode="inline"
              selectedKeys={activeLink}
              openKeys={openKeys}
              onSelect={(e) => {
                const dynamicSelectedRoute = Object.keys(dynamicDocsRoutes).find(
                  (key) => dynamicDocsRoutes[key as keyof typeof dynamicDocsRoutes]?.id?.[0] === e.key
                );
                if (dynamicSelectedRoute) {
                  window.location.href = dynamicSelectedRoute;
                }
              }}
              // defaultSelectedKeys={activeLink}
              // defaultOpenKeys={openKeys}
              onOpenChange={onOpenChange}
              items={menuItems}
            />
          </Sider>
        }
        rightComponent={
          <Layout className={styles["right-layout"]}>
            <Header className={styles["header"]}>
              <Space size={"large"}>
                {createElement(
                  collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                  {
                    className: styles["trigger"],
                    onClick: () => setCollapsed(!collapsed),
                  }
                )}
                <Breadcrumb
                  className={styles["breadcrumb"]}
                  items={breadcrumbItems}
                />
              </Space>
              <Space size={"middle"}>
                <Dropdown
                  className={styles["dropdown"]}
                  menu={{ items: languageItems, onClick: onClickLanguage }}
                >
                  <a href="." onClick={(e) => e.preventDefault()}>
                    <Space>
                      <GlobalOutlined />
                      {currentLanguageLabel}
                      <CaretDownOutlined />
                    </Space>
                  </a>
                </Dropdown>
                <Dropdown
                  className={styles["dropdown"]}
                  menu={{ items: userItems, onClick: onClickUser }}
                >
                  <a href="." onClick={(e) => e.preventDefault()}>
                    <Space>
                      {currentUser?.login}
                      <CaretDownOutlined />
                    </Space>
                  </a>
                </Dropdown>
                <Dropdown
                  className={styles["dropdown"]}
                  menu={{ items: footerItems }}
                  trigger={["click"]}
                >
                  <a href="." onClick={(e) => e.preventDefault()}>
                    <DashOutlined />
                  </a>
                </Dropdown>
              </Space>
            </Header>
            <Content className={styles["content"]}>
              <ConfigProvider locale={ukUA}>{props.children}</ConfigProvider>
            </Content>
          </Layout>
        }
      />
    </Layout>
  );
}

const mapStateToProps = (state: StateTypes) => ({
  lang: state.lang?.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  changeLanguage: (language: string) =>
    dispatch({ type: Actions.CHANGE_LANGUAGE, language }),
});

export default connect(mapStateToProps, mapDispatchToProps)(MainLayout);
